import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import Calculation from "./Calculation";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import userResources from "api/userResources";

const LandPackage = ({
  LandPackage,
  register,
  errors,
  clearErrors,
  watch,
  setValue,
  getValues,
  control,
  updateData,
}) => {
  const [counties, setCounties] = useState([]);
  const [supplierData, setSupplierData] = useState([]);

  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getCountries = async () => {
    try {
      const response = await userResources.countries();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      // setCountryFilterData(response.data.data);

      setCounties(combinedData);

      if (updateData) {
        const toBoolean = (value) => String(value).toLowerCase() === "true";

        setValue(
          "land_package.landPackageDetails.package_name",
          updateData?.land_package?.landPackageDetails?.package_name
        );
        setValue(
          "land_package.landPackageDetails.country",
          Number(updateData?.land_package?.landPackageDetails?.country)
        );
        setValue(
          "land_package.landPackageDetails.start_date",
          updateData?.land_package?.landPackageDetails?.start_date
        );
        setValue(
          "land_package.landPackageDetails.end_date",
          updateData?.land_package?.landPackageDetails?.end_date
        );
        setValue(
          "land_package.landPackageDetails.operator",
          updateData?.land_package?.landPackageDetails?.operator
        );

        // calculation update
        // land_package
        setValue(
          `land_package.passengers.adt`,
          Number(updateData?.land_package?.passengers?.adt)
        );
        setValue(
          `land_package.passengers.chd`,
          Number(updateData?.land_package?.passengers?.chd)
        );
        setValue(
          `land_package.passengers.inf`,
          Number(updateData?.land_package?.passengers?.inf)
        );
        setValue(
          `land_package.landpackage_from_pax.baseFare.adt1`,
          Number(updateData?.land_package?.landpackage_from_pax?.baseFare?.adt1)
        );
        setValue(
          `land_package.landpackage_from_pax.baseFare.chd1`,
          Number(updateData?.land_package?.landpackage_from_pax?.baseFare?.chd1)
        );
        setValue(
          `land_package.landpackage_from_pax.baseFare.inf1`,
          Number(updateData?.land_package?.landpackage_from_pax?.baseFare?.inf1)
        );
        setValue(
          `land_package.landpackage_from_pax.gstHst.adt1`,
          Number(updateData?.land_package?.landpackage_from_pax?.gstHst?.adt1)
        );
        setValue(
          `land_package.landpackage_from_pax.gstHst.chd1`,
          Number(updateData?.land_package?.landpackage_from_pax?.gstHst?.chd1)
        );
        setValue(
          `land_package.landpackage_from_pax.gstHst.inf1`,
          Number(updateData?.land_package?.landpackage_from_pax?.gstHst?.inf1)
        );
        setValue(
          `land_package.landpackage_from_pax.taxes.adt1`,
          Number(updateData?.land_package?.landpackage_from_pax?.taxes?.adt1)
        );
        setValue(
          `land_package.landpackage_from_pax.taxes.chd1`,
          Number(updateData?.land_package?.landpackage_from_pax?.taxes?.chd1)
        );
        setValue(
          `land_package.landpackage_from_pax.taxes.inf1`,
          Number(updateData?.land_package?.landpackage_from_pax?.taxes?.inf1)
        );
        setValue(
          `land_package.landpackage_from_pax.amountPaid`,
          Number(updateData?.land_package?.landpackage_from_pax?.amountPaid)
        );
        setValue(
          `land_package.landpackage_from_pax.refund`,
          Number(updateData?.land_package?.landpackage_from_pax?.refund)
        );
        setValue(
          `land_package.landpackage_from_pax.refund_paid`,
          Number(updateData?.land_package?.landpackage_from_pax?.refund_paid)
        );
        setValue(
          `land_package.landpackage_from_pax.payment_received_from_pax`,
          toBoolean(
            updateData?.land_package?.landpackage_from_pax
              ?.payment_received_from_pax
          )
        );
        // Using supplierPax for the key and when accessing updateData
        setValue(
          `land_package.landpackage_to_supplier.baseFare.adt1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.baseFare?.adt1
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.baseFare.chd1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.baseFare?.chd1
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.baseFare.inf1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.baseFare?.inf1
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.gstHst.adt1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.gstHst?.adt1
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.gstHst.chd1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.gstHst?.chd1
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.gstHst.inf1`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.gstHst?.inf1
          )
        );

        setValue(
          `land_package.landpackage_to_supplier.paymentMade`,
          Number(updateData?.land_package?.landpackage_to_supplier?.paymentMade)
        );
        setValue(
          `land_package.landpackage_to_supplier.recall_commission_to_supplier`,
          Number(
            updateData?.land_package?.landpackage_to_supplier
              ?.recall_commission_to_supplier
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.refund`,
          Number(updateData?.land_package?.landpackage_to_supplier?.refund)
        );
        setValue(
          `land_package.landpackage_to_supplier.cash_in_hand`,
          Number(
            updateData?.land_package?.landpackage_to_supplier?.cash_in_hand
          )
        );

        setValue(
          `land_package.landpackage_to_supplier.refund_received_from_supplier`,
          toBoolean(
            updateData?.land_package?.landpackage_to_supplier
              ?.refund_received_from_supplier
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.payment_received_from_supplier`,
          Number(
            updateData?.land_package?.landpackage_to_supplier
              ?.payment_received_from_supplier
          )
        );
        setValue(
          `land_package.landpackage_to_supplier.commission_from_supplier`,
          toBoolean(
            updateData?.land_package?.landpackage_to_supplier
              ?.commission_from_supplier
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCountries();
    getSuppliers();
  }, []);

  return (
    <section className="p-2">
      <div>
        <p className="bg-[#ff4e41] px-2 text-white">Land Package:</p>
      </div>

      <div className="grid grid-cols-2 gap-x-2 sm:grid-cols-3">
        {/* Package Name Field */}
        <InputField
          label="Package Name"
          id="package_name"
          type="text"
          placeholder="Enter Package Name"
          register={register}
          name="land_package.landPackageDetails.package_name"
          rules={{ required: "Package Name is required" }}
          errorMessage={
            errors?.land_package?.landPackageDetails?.package_name?.message
          }
          onChange={() =>
            clearErrors("land_package.landPackageDetails.package_name")
          }
          bgAllDark={true}
        />
        <div>
          <label className="my-2 block text-sm font-medium text-[#ff4e41]">
            Country
          </label>
          <Select
            {...register(`land_package.landPackageDetails.country`, {
              required: "Country is required",
            })}
            value={counties.find(
              (source) =>
                source.value ===
                watch("land_package.landPackageDetails.country") // Use watch to get the current value
            )} // Controlled value
            onChange={(selectedOption) => {
              setValue(
                "land_package.landPackageDetails.country",
                selectedOption?.value || ""
              ); // Update handler using setValue from React Hook Form
              clearErrors("land_package.landPackageDetails.country");
            }}
            options={counties} // Format options
            isSearchable={true} // Enable search functionality
            placeholder="Select..."
            classNames={getSelectClassNames({
              isDisabled: false,
              selectProps: {},
              isSelected: false,
              value: watch("land_package.landPackageDetails.country"), // Use watch to get the current value
            })} // Pass parameters here
            formatOptionLabel={(data) => (
              <li
                className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                  !data.isSelected
                    ? `bg-gray-200 text-gray-900`
                    : `bg-blue-800 text-gray-200`
                }`}
              >
                {data.label}
              </li>
            )}
          />
          {errors?.land_package?.landPackageDetails?.country && (
            <span className="text-sm text-red-500">
              {errors?.land_package?.landPackageDetails?.country?.message}
            </span>
          )}
        </div>

        {/* Start Date Field */}
        <InputField
          label="Start Date"
          id="start_date"
          type="date"
          register={register}
          name="land_package.landPackageDetails.start_date"
          rules={{ required: "Start Date is required" }}
          errorMessage={
            errors?.land_package?.landPackageDetails?.start_date?.message
          }
          onChange={() =>
            clearErrors("land_package.landPackageDetails.start_date")
          }
          bgAllDark={true}
        />

        {/* End Date Field */}
        <InputField
          label="End Date"
          id="end_date"
          type="date"
          register={register}
          name="land_package.landPackageDetails.end_date"
          rules={{ required: "End Date is required" }}
          errorMessage={
            errors?.land_package?.landPackageDetails?.end_date?.message
          }
          onChange={() =>
            clearErrors("land_package.landPackageDetails.end_date")
          }
          bgAllDark={true}
        />

        {/* Operator Field */}
        <InputField
          label="Operator"
          type="text"
          placeholder="Enter Operator"
          register={register}
          name="land_package.landPackageDetails.operator"
          // rules={{ required: "Operator is required" }}
          // errorMessage={
          //   errors?.land_package?.landPackageDetails?.operator?.message
          // }
          // onChange={() =>
          //   clearErrors("land_package.landPackageDetails.operator")
          // }
          bgAllDark={true}
        />
      </div>

      <div className="mt-4">
        <Calculation
          supplierData={supplierData}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          watch={watch}
          setValue={setValue}
          control={control}
          getValues={getValues}
          LandPackage={LandPackage}
          landPackagePax={true}
          landPackageSupplier={true}
          updateData={updateData}
        />
      </div>
    </section>
  );
};

export default LandPackage;
